// extracted by mini-css-extract-plugin
export var advantages__slider = "advantages-module--advantages__slider--muei5";
export var advantages__sliderContainer = "advantages-module--advantages__slider-container--v3IqP";
export var advantages__card = "advantages-module--advantages__card--v9eog";
export var advantages__cardTitle = "advantages-module--advantages__card-title--8SqHw";
export var advantages__cardDesc = "advantages-module--advantages__card-desc--ZVhOo";